import React from "react";
import { NavLink, Link } from "react-router-dom";
import { AiOutlineWhatsApp } from "react-icons/ai";
import { useGetAllCategoryListQuery } from "../../../utils/api/category/category.api";
import { FiPhoneCall } from "react-icons/fi";
import { FaInstagram } from "react-icons/fa";
import Logo from "../../../assets/images/appImages/YeksinaHome_Footer.png";

const FrontFooter = () => {
  const { data } = useGetAllCategoryListQuery();
  const date = new Date();

  return (
    <footer className="footer-component">
      <div className="container pt-5 pb-4">
        <div className="row footer-main-content">
          {/* Colonne gauche - Yeksina Home et Contact */}
          <div className="col-lg-4 col-md-6 mb-4 footer-column">
            <div className="footer-logo-container">
              <img 
                src={Logo} 
                alt="Yeksina Home" 
                className="footer-logo"
              />
            </div>
            <h3 className="footer-brand-title">Yeksina Home</h3>
            <h4 className="footer-section-title no-underline">Nous contacter</h4>
            <div className="footer-contact-list">
              <div className="footer-contact-item">
                <AiOutlineWhatsApp className="footer-contact-icon" />
                <div className="footer-contact-text">
                  <span className="footer-contact-label">WhatsApp</span>
                  <Link 
                    to="https://wa.me/221777165656" 
                    className="footer-contact-link" 
                    target="_blank"
                  >
                    +221 77 716 56 56
                  </Link>
                </div>
              </div>
              <div className="footer-contact-item">
                <FiPhoneCall className="footer-contact-icon" />
                <div className="footer-contact-text">
                  <span className="footer-contact-label">Téléphone</span>
                  <Link 
                    to="tel:+221777165656" 
                    className="footer-contact-link"
                  >
                    +221 77 716 56 56
                  </Link>
                </div>
              </div>
            </div>
            <div className="footer-locations">
              <p className="footer-location-text">Dakar, Sénégal</p>
              <p className="footer-location-text">Abidjan, Côte d'Ivoire</p>
            </div>
          </div>

          {/* Colonne milieu - Notre carrelage */}
          <div className="col-lg-4 col-md-6 mb-4 footer-column">
            <h4 className="footer-section-title">Notre carrelage</h4>
            <ul className="footer-list">
              {data?.results?.slice(0, 4).map((item) => (
                <li key={item?.id}>
                  <Link
                    state={{ catgoryId: item?.id }}
                    className="footer-link"
                    to={`/produits?categorie=${item?.slug}`}
                  >
                    {item?.nom}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Colonne droite - Liens utiles */}
          <div className="col-lg-4 col-md-6 mb-4 footer-column">
            <h4 className="footer-section-title">Liens utiles</h4>
            <ul className="footer-list">
              <li>
                <NavLink className="footer-link" to="/a-propos-de-nous">
                  Qui sommes-nous ?
                </NavLink>
              </li>
              <li>
                <NavLink className="footer-link" to="/politique-de-confidentialite">
                  Politique de confidentialité
                </NavLink>
              </li>
              <li>
                <NavLink className="footer-link" to="/cgu">
                  Conditions générales de vente
                </NavLink>
              </li>
            </ul>
            <div className="footer-social-icons">
              <Link
                className="footer-social-icon"
                to="https://www.instagram.com/yeksinahome?igsh=MzRmZG81ZXN1YWdp"
                target="_blank"
                title="Instagram"
              >
                <FaInstagram />
              </Link>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-copyright">
          <div className="footer-separator"></div>
          <p className="footer-copyright-text">
            © {date.getFullYear()}, <span className="footer-copyright-highlight">Yeksina Home</span>, Commerce électronique propulsé par{" "}
            <Link
              to="https://easymarket.sn"
              target="_blank"
              className="footer-copyright-highlight"
            >
              Easymarket.sn
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FrontFooter;